import { render, staticRenderFns } from "./newsLiputanSemasa.vue?vue&type=template&id=fcf43bb4&scoped=true&"
import script from "./newsLiputanSemasa.vue?vue&type=script&lang=js&"
export * from "./newsLiputanSemasa.vue?vue&type=script&lang=js&"
import style0 from "./newsLiputanSemasa.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newsLiputanSemasa.vue?vue&type=style&index=1&id=fcf43bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf43bb4",
  null
  
)

export default component.exports